import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/midnight-lab.css';

function FRCAchievementsPage() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    const section = sectionRef.current;
    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <div style={{ backgroundColor: 'var(--color-bg-primary)', paddingTop: '100px', minHeight: '80vh' }}>
      <section
        ref={sectionRef}
        style={{
          padding: 'var(--space-24) var(--space-4)',
          maxWidth: '1400px',
          margin: '0 auto',
          textAlign: 'center',
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(30px)',
          transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
        }}
      >
        <h1 style={{
          fontFamily: 'var(--font-sans)',
          fontSize: 'clamp(3rem, 6vw, 5rem)',
          fontWeight: 700,
          color: 'var(--color-text-primary)',
          marginBottom: 'var(--space-6)',
          letterSpacing: '-0.03em'
        }}>
          FRC Achievements
        </h1>
        <p style={{
          fontFamily: 'var(--font-sans)',
          fontSize: 'clamp(1.5rem, 3vw, 2rem)',
          color: 'var(--color-text-secondary)',
          lineHeight: 1.7,
          maxWidth: '700px',
          margin: '0 auto var(--space-12)'
        }}>
          Coming Soon
        </p>
        <p style={{
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--text-lg)',
          color: 'var(--color-text-secondary)',
          lineHeight: 1.7,
          maxWidth: '600px',
          margin: '0 auto var(--space-8)'
        }}>
          Our FRC program is launching in 2025. Check back soon for our competition results and achievements.
        </p>
        <div style={{
          display: 'flex',
          gap: 'var(--space-4)',
          justifyContent: 'center',
          flexWrap: 'wrap',
          marginTop: 'var(--space-12)'
        }}>
          <Link
            to="/frc"
            style={{
              padding: '16px 40px',
              backgroundColor: 'var(--color-text-primary)',
              color: 'var(--color-text-light)',
              fontSize: 'var(--text-base)',
              fontWeight: 600,
              letterSpacing: '1px',
              textTransform: 'uppercase',
              textDecoration: 'none',
              fontFamily: 'var(--font-sans)',
              border: '2px solid var(--color-text-primary)',
              transition: 'all var(--transition-base)',
              display: 'inline-block'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'var(--color-frozen-lake)';
              e.target.style.borderColor = 'var(--color-frozen-lake)';
              e.target.style.color = 'var(--color-text-primary)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'var(--color-text-primary)';
              e.target.style.borderColor = 'var(--color-text-primary)';
              e.target.style.color = 'var(--color-text-light)';
            }}
          >
            Learn About FRC
          </Link>
          <Link
            to="/join"
            style={{
              padding: '16px 40px',
              backgroundColor: 'transparent',
              color: 'var(--color-text-primary)',
              fontSize: 'var(--text-base)',
              fontWeight: 600,
              letterSpacing: '1px',
              textTransform: 'uppercase',
              textDecoration: 'none',
              fontFamily: 'var(--font-sans)',
              border: '2px solid var(--color-text-primary)',
              transition: 'all var(--transition-base)',
              display: 'inline-block'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'var(--color-text-primary)';
              e.target.style.color = 'var(--color-text-light)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = 'var(--color-text-primary)';
            }}
          >
            Join FRC
          </Link>
        </div>
      </section>
    </div>
  );
}

export default FRCAchievementsPage;

